import { Box, Container } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
// import { useForm } from "react-hook-form";
import { useParams, useNavigate } from 'react-router-dom'
import CustomButton from '../../../../../Components/CustomButton/CustomButton'
// import { Input } from "../../../../../Components/Input";
import { makeGetRequest, makePostRequest, makeDeleteRequest } from '../../../../../utils/api'
import urls from '../../../../../utils/urls'
import CreateOperationForm from './CreateOperationForm'
import ListOperations from './ListOperations'
// import ComboBox from '../../../../../Components/ComboBox'
import EditOperationForm from './EditOperationForm'
import EditPlanFinancementOperationForm from './EditPlanFinancementOperationForm'
// import SupprimerOperationForm from './SupprimerOperationForm'

export const ImmoFinancement = () => {
  let navigate = useNavigate()

  const { id } = useParams()
  const [operations, setOperations] = useState({})
  const [restToPay, setRestToPay] = useState()
  const [openForm, setOpenForm] = useState(false)
  const [openModifi, setModifi] = useState(false)

  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [selected, setSelected] = useState(false)
  // const [selectedSupprimer, setSelectedSupprimer] = useState(false)

  useEffect(() => {
    fetchOperations()
    //fetchVehicleDetail();
  }, [])

  // const fetchVehicleDetail = async () => {
  //   const response = await makeGetRequest(urls.crudVehiclesOperations + id, {})
  //   if (response.status === 200) {

  //     // setVehicule(response.data)
  //     setRestToPay(response.data.RestToPay);

  //   }
  // }
  const fetchOperations = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.curdPlanImmoFinancementViewDashboard}`

    if (pagination !== '') {
      //general=true&
      url += pagination
    }
    const response = await makeGetRequest(url + '?ImmoObjectID=' + id, {}, true)
    if (response.status === 200) {
      if (response.data.results.length === 0) {
        setOpenForm(true)
      } else {
        setModifi(true)
      }
      setOperations({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      // const response = await makePostRequest(
      //   urls.deleteBulkOperations,
      //   { selected: selectedRows },
      //   {},
      //   false
      // );
      // if ( response.status === 200 )
      // {
      // }
    }
  }

  const deleteImmoFinancment = async () => {
    const response = await makeDeleteRequest(urls.curdImmoFinancementDelete + id + '/', {}, true)
    if (response.status === 200) {
      navigate('/domicile/monimmobilier')
    }
  }

  return (
    <>
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box>
            {openForm ? (
              <CreateOperationForm
                setOperations={setOperations}
                openForm={openForm}
                setOpenForm={setOpenForm}
                setModifi={setModifi}
              />
            ) : (
              ''
            )}

            <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  // formRef.current.handleClickOpen(true)
                  setSelectedRowsParams({
                    ...operations.results.filter((v) => v.id === selectedRows[0]),
                  })
                  setSelected(true)
                } else {
                  setSelected(false)
                  alert('Please Select one document for modifier')
                }
              }}
            >
              Modifier opération
            </CustomButton>
            {selected ? (
              <EditOperationForm
                setOperations={setOperations}
                setSelected={setSelected}
                params={selectedRowsParams}
                operations={operations}
              />
            ) : (
              ''
            )}

            <CustomButton onClick={deleteBulkOperations}>supprimer operation</CustomButton>

            {openModifi && (
              <>
                <EditPlanFinancementOperationForm
                  setOperations={setOperations}
                  setSelected={setSelected}
                  params={selectedRowsParams}
                  operations={operations}
                />
                <CustomButton onClick={deleteImmoFinancment}>supprimer financement</CustomButton>
              </>
            )}

            {/* supprimer */}
            {/* <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  // formRef.current.handleClickOpen(true)
                  setSelectedRowsParams({...operations.results.filter((v) => v.id === selectedRows[0])})
                  // setSelectedSupprimer(true)
                } else {
                  // setSelectedSupprimer(false)
                  alert('Please Select one document for supprimer')
                }
              }}
            >
              supprimer
            </CustomButton> */}
            {/* {selectedSupprimer ? (

              <SupprimerOperationForm
                      setOperations={setOperations}
                      setSelected={setSelected}
                      params={selectedRowsParams}
                      operations={operations}
                      
                    />
            ):(
              ''
            )} */}
          </Box>
        </Box>

        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
        />
      </Container>
    </>
  )
}
